// 卡片状态枚举
export enum CurrentCardStatus {
  Active = '1',
  Frozen = '2',
}

// 卡片状态（旧版本，保留兼容性）
export const enum CardStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  BLOCKED = 'blocked'
}

// 卡片类型
export const enum CardType {
  VIRTUAL = 'virtual',
  PHYSICAL = 'physical'
}

/**
 * 卡片信息接口
 * @param id 卡片ID
 * @param type 卡片类型
 * @param status 卡片状态
 * @param number 卡片号码
 * @param balance 卡片余额
 * @param currency 卡片货币
 */
export interface CardInfo {
  id: string
  type: CardType
  status: CardStatus
  number: string
  balance: string
  currency: string
}
